// Iter 904 (Kamel) — 📱 barre de navigation en bas d'écran (smartphone uniquement) : les 4 actions clés + Menu
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Routes où la barre ne s'affiche pas : admin, formulaire 4 écrans (ses propres boutons), pages à token, fiche voyage (barre S'inscrire dédiée)
export const mobileNavVisible = (pathname) =>
  !/^\/(admin|@|Tintin|inscription|formulaire-inscription|inscription-groupe|apercu-verrouillage|mes-pieces|mon-bus|sondage|verification-vol|voyage\/|trips\/)/i.test(pathname);

const Ico = ({ d }) => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d={d} />
  </svg>
);

const ITEMS = [
  { to: '/', label: 'Accueil', d: 'M3 12l9-9 9 9M5 10v10h5v-6h4v6h5V10', match: (p) => p === '/' },
  { to: '/voyages', label: 'Voyages', d: 'M12 2a7 7 0 017 7c0 5-7 13-7 13S5 14 5 9a7 7 0 017-7zm0 9.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z', match: (p) => p.startsWith('/voyages') },
  { to: '/inscription', label: "S'inscrire", d: 'M12 4v16m8-8H4', cta: true, match: () => false },
  { to: '/moi', label: 'Mon espace', d: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM4 21a8 8 0 0116 0', match: (p) => p === '/moi' || p.startsWith('/espace-adherent') },
];

export default function MobileNav() {
  const { pathname } = useLocation();
  if (!mobileNavVisible(pathname)) return null;
  const openMenu = () => { window.scrollTo({ top: 0, behavior: 'smooth' }); window.dispatchEvent(new CustomEvent('raav-toggle-menu')); };
  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-[60] bg-white/95 backdrop-blur border-t border-gray-200 shadow-[0_-4px_16px_rgba(0,0,0,0.08)]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }} data-testid="mobile-bottom-nav" aria-label="Navigation principale">
      <div className="grid grid-cols-5 h-16">
        {ITEMS.map((it) => {
          const active = it.match(pathname);
          if (it.cta) return (
            <Link key={it.to} to={it.to} onClick={() => window.scrollTo(0, 0)} className="flex flex-col items-center justify-center -mt-4" data-testid="mobile-nav-inscription">
              <span className="w-14 h-14 rounded-full bg-[#C60B1E] text-white flex items-center justify-center shadow-lg border-4 border-white"><Ico d={it.d} /></span>
              <span className="text-[10px] font-extrabold text-[#C60B1E] -mt-1">{it.label}</span>
            </Link>
          );
          return (
            <Link key={it.to} to={it.to} onClick={() => window.scrollTo(0, 0)}
              className={`flex flex-col items-center justify-center gap-0.5 text-[10px] font-bold ${active ? 'text-[#1E3A5F]' : 'text-gray-500'}`}
              aria-current={active ? 'page' : undefined} data-testid={`mobile-nav-${it.label.toLowerCase().replace(/[^a-z]/g, '')}`}>
              <span className={`px-3 py-0.5 rounded-full ${active ? 'bg-[#79c9ea]/30' : ''}`}><Ico d={it.d} /></span>
              {it.label}
            </Link>
          );
        })}
        <button type="button" onClick={openMenu} className="flex flex-col items-center justify-center gap-0.5 text-[10px] font-bold text-gray-500" data-testid="mobile-nav-menu">
          <span className="px-3 py-0.5"><Ico d="M4 6h16M4 12h16M4 18h16" /></span>
          Menu
        </button>
      </div>
    </nav>
  );
}
